module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "application"
  }, [_c('div', {
    staticClass: "time"
  }), _c('div', {
    staticClass: "shift-name"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.application.shift.real_start, 'HH:mm')) + " - ")]), _c('strong', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.application.shift.shift_type))])]), (_vm.application.shift.comments) ? _c('div', {
    staticClass: "comments"
  }, [_vm._v(_vm._s(_vm.application.shift.comments))]) : _vm._e(), _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classNA,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('not_available')
      }
    }
  }, [_vm._m(0), _c('br'), _c('span', [_vm._v("Nein")])])]), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classYes,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('yes')
      }
    }
  }, [_vm._m(1), _c('br'), _c('span', [_vm._v("Okay")])])]), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classAbs,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('absolutely')
      }
    }
  }, [_vm._m(2), _c('br'), _c('span', [_vm._v("Ja")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9571eac"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Application.vue
// module id = 1089
// module chunks = 1